import { render, staticRenderFns } from "./CatalogProductList.vue?vue&type=template&id=44b70f58&scoped=true&"
import script from "./CatalogProductList.vue?vue&type=script&lang=js&"
export * from "./CatalogProductList.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductList.vue?vue&type=style&index=0&id=44b70f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b70f58",
  null
  
)

export default component.exports